import { Box, Modal, Typography } from '@mui/material'
import styles from './modalStyle.module.scss'
const CommonDeleteModal = ({
	heading,
	subHeading,
	className,
	handleOpen,
	handleClose,
	footerContent,
	children,
	open,
	modalBody,
	Icon = '/images/DeleteModal.svg',
	ClassIcon = '',
	modalFooter = '',
	subHeadingClass = '',
	...rest
}) => {
	const style = {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
	}
	return (
		<>
			<div {...rest}>
				<Modal
					open={open}
					onClose={handleClose}
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
					className={`${styles.modalWrp} ${styles.modalDeleteWrp} ${className}`}
				>
					<Box sx={style} className={`${styles.modalInner}`}>
						<div className={`${styles.modalHeader}`}>
							{Icon && (
								<figure
									className={`${styles.modalHeaderImg} ${ClassIcon}`}
								>
									<img src={Icon} alt={heading} />
								</figure>
							)}

							<Typography variant="h2">{heading}</Typography>
							{subHeading && (
								<Typography className={subHeadingClass}>{subHeading}</Typography>
							)}
						</div>

						<div className={`${styles.modalBody} ${modalBody}`}>
							{children}
						</div>
						<div className={`${styles.modalFooter} ${modalFooter}`}>
							{footerContent}
						</div>
						<div
							className={`${styles.closeIcon}`}
							onClick={handleClose}
						>
							<img src="/images/modal-close-icon.svg" alt="close" />
						</div>
					</Box>
				</Modal>
			</div>
		</>
	)
}

export default CommonDeleteModal
